
<template>
  <!--系统消息-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'systemMsg',
  data () {
    return {
      searchList: [
        { props: ['title'], placeholder: '标题', inputType: 'input' },
        { props: ['aims'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.sendStatusList, inputType: 'select' },
        { props: ['scope_type'], placeholder: '用户范围', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['发布时间', '发布时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$children[0].toEdit(record), key: 'edit' },
        { text: '删除', handle: (record) => this.$children[0].showDeleteConfirm(record), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'id', align: 'left', width: '' },
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '发布时间', dataIndex: 'create_time_desc', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_str', align: 'left', width: '' },
        { title: '应用', dataIndex: 'aims_desc', align: 'left', width: '' },
        { title: '用户范围', dataIndex: 'scope_type_desc', align: 'left', width: '' },
        { title: '送达 | 阅读', dataIndex: 'sendAndRead', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: undefined,
        aims: undefined,
        status: undefined,
        scope_type: undefined,
        create_date: undefined
      },
      listApi: {
        url: '/message-list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addSystemMsg',
        title: '修改系统消息'
      },
      deleteParam: {
        url: '/message-list',
        param: { pk_key: 'id', pk_val: '' },
        title: '系统消息',
        key: 'title'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        { index: 1, query: 'message_aims_type_desc', scope: 'searchList' }, // 应用
        { index: 3, query: 'scope_type_desc', scope: 'searchList' } // 范围
      ];
      paramArr.forEach((el) => {
        this.typeSelect(el);
      });
    },
    resHandle (res) {
      res.forEach((el) => {
        el.sendAndRead = `${el.total_num} | ${el.read_num}`;
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/systemMsg/systemMsg.vue